/**
 * GENERATED FILE — DO NOT EDIT.
 * Run `pnpm a2a-contract:generate` after changing the
 * canonical Pydantic contract.
 */
/** Cross-runtime examples covering every custom semantic validator. */
export const semanticConformance = {
  cases: [
    {
      description: "An annotation with neither a note nor a mark is rejected.",
      id: "annotation-guidance.empty",
      ruleId: "annotation-guidance",
      schemaRoot: "AuthorSopResume",
      valid: false,
      value: {
        kind: "annotation",
        note: "",
        strokes: [],
      },
    },
    {
      description: "Unicode whitespace alone is not textual guidance.",
      id: "annotation-guidance.unicode-whitespace",
      ruleId: "annotation-guidance",
      schemaRoot: "AuthorSopResume",
      valid: false,
      value: {
        kind: "annotation",
        note: "",
        strokes: [],
      },
    },
    {
      description: "A non-blank note is sufficient annotation guidance.",
      id: "annotation-guidance.valid-note",
      ruleId: "annotation-guidance",
      schemaRoot: "AuthorSopResume",
      valid: true,
      value: {
        kind: "annotation",
        note: "Use the highlighted button",
        strokes: [],
      },
    },
    {
      description: "A visual mark is sufficient annotation guidance.",
      id: "annotation-guidance.valid-stroke",
      ruleId: "annotation-guidance",
      schemaRoot: "AuthorSopResume",
      valid: true,
      value: {
        kind: "annotation",
        note: "",
        strokes: [
          {
            intent: "act_here",
            points: [
              {
                x: 0.5,
                y: 0.5,
              },
            ],
          },
        ],
      },
    },
    {
      description: "Path ids must be unique within a branch.",
      id: "branch-path-cardinality-and-uniqueness.duplicate-id",
      ruleId: "branch-path-cardinality-and-uniqueness",
      schemaRoot: "SopBranch",
      valid: false,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "otherwise",
            pathId: "matched",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "Path labels must be unique within a branch.",
      id: "branch-path-cardinality-and-uniqueness.duplicate-label",
      ruleId: "branch-path-cardinality-and-uniqueness",
      schemaRoot: "SopBranch",
      valid: false,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "same outcome",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "same outcome",
            pathId: "open",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "A branch requires at least two paths.",
      id: "branch-path-cardinality-and-uniqueness.too-few",
      ruleId: "branch-path-cardinality-and-uniqueness",
      schemaRoot: "SopBranch",
      valid: false,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
        ],
      },
    },
    {
      description:
        "Two paths with distinct durable ids and labels are accepted.",
      id: "branch-path-cardinality-and-uniqueness.valid",
      ruleId: "branch-path-cardinality-and-uniqueness",
      schemaRoot: "SopBranch",
      valid: true,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "otherwise",
            pathId: "open",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "A branch condition cannot start with whitespace.",
      id: "branch-text.condition-leading-space",
      ruleId: "branch-text",
      schemaRoot: "SopBranch",
      valid: false,
      value: {
        condition: " leading whitespace",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "otherwise",
            pathId: "open",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "A branch label cannot contain a Unicode line separator.",
      id: "branch-text.label-line-separator",
      ruleId: "branch-text",
      schemaRoot: "SopBranch",
      valid: false,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "otherwise",
            pathId: "open",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "Canonical single-line condition and labels are accepted.",
      id: "branch-text.valid",
      ruleId: "branch-text",
      schemaRoot: "SopBranch",
      valid: true,
      value: {
        condition: "the invoice is already matched",
        paths: [
          {
            label: "already matched",
            pathId: "matched",
            stepIds: ["step-1"],
          },
          {
            label: "otherwise",
            pathId: "open",
            stepIds: ["step-2"],
          },
        ],
      },
    },
    {
      description: "Guide frame ids must be unique within a run-SOP input.",
      id: "guide-frame-uniqueness.duplicate-id",
      ruleId: "guide-frame-uniqueness",
      schemaRoot: "RunSopInput",
      valid: false,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        guide: {
          frames: [
            {
              frameId: "f-1",
              ordinal: 1,
            },
            {
              frameId: "f-1",
              ordinal: 2,
            },
          ],
          mode: "always",
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
      },
    },
    {
      description:
        "Guide frame ordinals must be unique within a run-SOP input.",
      id: "guide-frame-uniqueness.duplicate-ordinal",
      ruleId: "guide-frame-uniqueness",
      schemaRoot: "RunSopInput",
      valid: false,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        guide: {
          frames: [
            {
              frameId: "f-1",
              ordinal: 1,
            },
            {
              frameId: "f-2",
              ordinal: 1,
            },
          ],
          mode: "always",
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
      },
    },
    {
      description:
        "Guide frame ids and ordinals are unique within a run-SOP input.",
      id: "guide-frame-uniqueness.valid",
      ruleId: "guide-frame-uniqueness",
      schemaRoot: "RunSopInput",
      valid: true,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        guide: {
          frames: [
            {
              frameId: "f-1",
              ordinal: 1,
            },
            {
              frameId: "f-2",
              ordinal: 2,
            },
          ],
          mode: "always",
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
      },
    },
    {
      description: "Session rules use the camel-case wire alias.",
      id: "session-rules.BrowserUseInput.sessionRules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "BrowserUseInput",
      valid: true,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
        sessionRules: ["Stop on disconnect."],
      },
    },
    {
      description: "Session rules use the camel-case wire alias.",
      id: "session-rules.BrowserUseInput.session_rules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "BrowserUseInput",
      valid: false,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
        session_rules: ["Stop on disconnect."],
      },
    },
    {
      description: "Session rules use the camel-case wire alias.",
      id: "session-rules.RunSopInput.sessionRules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "RunSopInput",
      valid: true,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
        sessionRules: ["Stop on disconnect."],
      },
    },
    {
      description: "Session rules use the camel-case wire alias.",
      id: "session-rules.RunSopInput.session_rules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "RunSopInput",
      valid: false,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
        session_rules: ["Stop on disconnect."],
      },
    },
    {
      description:
        "Each procedure's session rules use the camel-case wire alias.",
      id: "session-rules.procedure.sessionRules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "BrowserUseInput",
      valid: true,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        procedures: [
          {
            name: "Match",
            sessionRules: ["Stop."],
            steps: [],
          },
        ],
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
      },
    },
    {
      description:
        "Each procedure's session rules use the camel-case wire alias.",
      id: "session-rules.procedure.session_rules",
      ruleId: "session-rules-wire-alias",
      schemaRoot: "BrowserUseInput",
      valid: false,
      value: {
        agent: {
          model: {
            modelId: "claude-sonnet-5-5",
            provider: "anthropic",
          },
        },
        procedures: [
          {
            name: "Match",
            session_rules: ["Stop."],
            steps: [],
          },
        ],
        session: {
          browser: {
            cdpUrl: "ws://x",
          },
        },
      },
    },
    {
      description: "Mixed-case and punctuation are rejected.",
      id: "sop-parameter-name.mixed-case",
      ruleId: "sop-parameter-name",
      schemaRoot: "SopParam",
      valid: false,
      value: {
        description: "Invoice identifier.",
        name: "Invoice-ID",
        required: true,
      },
    },
    {
      description: "Lowercase snake-case parameter names are accepted.",
      id: "sop-parameter-name.valid",
      ruleId: "sop-parameter-name",
      schemaRoot: "SopParam",
      valid: true,
      value: {
        description: "Invoice identifier.",
        name: "invoice_id",
        required: true,
      },
    },
    {
      description: "An action discriminator cannot carry a branch payload.",
      id: "sop-step-discriminated-shape.action-with-branch",
      ruleId: "sop-step-discriminated-shape",
      schemaRoot: "SopStep",
      valid: false,
      value: {
        branch: {
          condition: "the invoice is already matched",
          paths: [
            {
              label: "already matched",
              pathId: "matched",
              stepIds: ["step-1"],
            },
            {
              label: "otherwise",
              pathId: "open",
              stepIds: ["step-2"],
            },
          ],
        },
        constraints: ["You MUST select the requested invoice"],
        description: "Open the invoice details.",
        index: 1,
        name: "Open invoice",
        surface: "semantic",
      },
    },
    {
      description: "A branch discriminator requires a branch payload.",
      id: "sop-step-discriminated-shape.branch-without-payload",
      ruleId: "sop-step-discriminated-shape",
      schemaRoot: "SopStep",
      valid: false,
      value: {
        constraints: ["You MUST select the requested invoice"],
        description: "Open the invoice details.",
        index: 1,
        kind: "branch",
        name: "Open invoice",
        surface: "semantic",
      },
    },
    {
      description: "An action step without a branch payload is accepted.",
      id: "sop-step-discriminated-shape.valid-action",
      ruleId: "sop-step-discriminated-shape",
      schemaRoot: "SopStep",
      valid: true,
      value: {
        constraints: ["You MUST select the requested invoice"],
        description: "Open the invoice details.",
        index: 1,
        name: "Open invoice",
        surface: "semantic",
      },
    },
    {
      description: "Plain prose without an RFC 2119 keyword is rejected.",
      id: "sop-step-rfc2119-constraints.missing-keyword",
      ruleId: "sop-step-rfc2119-constraints",
      schemaRoot: "SopStep",
      valid: false,
      value: {
        constraints: ["Select the requested invoice"],
        description: "Open the invoice details.",
        index: 1,
        name: "Open invoice",
        surface: "semantic",
      },
    },
    {
      description:
        "A keyword embedded in a Unicode word is rejected in both runtimes.",
      id: "sop-step-rfc2119-constraints.unicode-word-boundary",
      ruleId: "sop-step-rfc2119-constraints",
      schemaRoot: "SopStep",
      valid: false,
      value: {
        constraints: ["éMUSTé"],
        description: "Open the invoice details.",
        index: 1,
        name: "Open invoice",
        surface: "semantic",
      },
    },
    {
      description:
        "A delimited RFC 2119 keyword satisfies the constraint rule.",
      id: "sop-step-rfc2119-constraints.valid",
      ruleId: "sop-step-rfc2119-constraints",
      schemaRoot: "SopStep",
      valid: true,
      value: {
        constraints: ["You MUST select the requested invoice"],
        description: "Open the invoice details.",
        index: 1,
        name: "Open invoice",
        surface: "semantic",
      },
    },
  ],
  rules: [
    {
      caseId: "branch-text",
      schemaPointers: ["/$defs/SopBranch/properties/condition/pattern"],
      validator:
        "ai_service.a2a.author_sop.draft.models.SopBranch._condition_valid",
    },
    {
      caseId: "branch-path-cardinality-and-uniqueness",
      schemaPointers: [
        "/$defs/SopBranch/properties/paths/minItems",
        "/$defs/SopBranch/properties/paths/x-uniqueProperties",
      ],
      validator:
        "ai_service.a2a.author_sop.draft.models.SopBranch._paths_valid",
    },
    {
      caseId: "branch-text",
      schemaPointers: ["/$defs/SopBranchPath/properties/label/pattern"],
      validator:
        "ai_service.a2a.author_sop.draft.models.SopBranchPath._label_valid",
    },
    {
      caseId: "sop-parameter-name",
      schemaPointers: ["/$defs/SopParam/properties/name/pattern"],
      validator: "ai_service.a2a.author_sop.draft.models.SopParam._snake_case",
    },
    {
      caseId: "sop-step-discriminated-shape",
      schemaPointers: ["/$defs/SopStep/allOf/0/oneOf"],
      validator: "ai_service.a2a.author_sop.draft.models.SopStep._kind_shape",
    },
    {
      caseId: "sop-step-rfc2119-constraints",
      schemaPointers: [
        "/$defs/SopStep/properties/constraints/minItems",
        "/$defs/SopStep/properties/constraints/items/pattern",
      ],
      validator:
        "ai_service.a2a.author_sop.draft.models.SopStep._non_empty_rfc2119",
    },
    {
      caseId: "annotation-guidance",
      schemaPointers: ["/$defs/AnnotationResume/allOf/0/anyOf"],
      validator:
        "ai_service.a2a.contract.v1.models.AnnotationResume.require_guidance",
    },
    {
      caseId: "session-rules-wire-alias",
      schemaPointers: ["/$defs/BrowserUseInput/additionalProperties"],
      validator:
        "ai_service.a2a.contract.v1.models.BrowserUseInput._session_rules_wire_alias",
    },
    {
      caseId: "session-rules-wire-alias",
      schemaPointers: ["/$defs/RunSopInput/additionalProperties"],
      validator:
        "ai_service.a2a.contract.v1.models.RunSopInput._session_rules_wire_alias",
    },
    {
      caseId: "guide-frame-uniqueness",
      schemaPointers: [
        "/$defs/GuideInput/properties/frames/x-uniqueProperties",
      ],
      validator:
        "ai_service.a2a.run_sop.config.models.GuideInput._require_unique_frames",
    },
    {
      caseId: "session-rules-wire-alias",
      schemaPointers: ["/$defs/ProcedureInput/additionalProperties"],
      validator:
        "ai_service.a2a.run_sop.config.models.ProcedureInput._session_rules_wire_alias",
    },
  ],
} as const;

/** Executable schema locations and corpus group owned by each Python validator. */
export const semanticValidatorRules = semanticConformance.rules;

/** Language-neutral examples executed exhaustively by Pydantic and Ajv tests. */
export const semanticConformanceCases = semanticConformance.cases;

export type SemanticConformanceCase = (typeof semanticConformanceCases)[number];
